/* =========================================================================
   Foxhills charm page: Browse chains + Add on / Style with.

   Modelled on mejuri.com/gb/en/products/cosmic-charm (Louise, 12 Oct 2026):
   1. "Browse chains for charms" above Add to bag opens a side panel of the
      chains and bracelets paired with this charm. Picking one puts it in the
      bag together with the charm.
   2. After adding, an "Added to your bag" panel replaces the cart drawer for
      charms, with two tabs: Add on (matching chains/bracelets) and Style with
      (other charms). Each has its own Add button.
   3. "Build your charm stack" (sections/fc-charm-stack.liquid): clicking a
      step image opens "Shop the look", the photo beside the products in it,
      each with Add + (FoxCharm.looks). Also on the Birthstone + Zodiac
      collection page, where FoxCharm has looks only.

   Data comes from window.FoxCharm (snippets/fox-charm-data.liquid), built from
   the charm's product metafields. birthstone.js initAdd asks this file for the
   chosen chain before adding and hands the result back after.
   ========================================================================= */
(function () {
  'use strict';

  var FC = window.FoxCharm;
  if (!FC || (!FC.lists && !FC.looks)) return;

  /* Off the charm page (the collection page's charm stack) only looks exist. */
  var L = FC.lists || { necklaces: [], bracelets: [], style: [] };
  L.charms = L.charms || [];
  /* Chain mode (chains/bracelets with custom.compatible_charms): the reverse
     of the charm page. Browse lists the charms that fit, the chosen charm goes
     in with the chain, and Add on offers more of them. */
  var CHAIN = FC.mode === 'chain';
  var CK = FC.chainKind || 'necklace';
  var chosen = null;
  var baseLabel = null;
  var PANEL_ID = 'FoxCharmPanel';

  function money(c) {
    try { return window.theme.Currency.formatMoney(c, window.theme.settings.moneyFormat); }
    catch (e) { return '£' + (c / 100).toFixed(2); }
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }
  function firstAvail(p) { return p.variants.filter(function (v) { return v.available; })[0] || p.variants[0]; }
  function findProduct(id) {
    var all = L.necklaces.concat(L.bracelets, L.style, L.charms);
    (FC.looks || []).forEach(function (l) { all = all.concat(l.items); });
    all = all.concat(FC.pool || []);
    for (var i = 0; i < all.length; i++) if (all[i].id === id) return all[i];
    return null;
  }
  function kindOf(p) { return CHAIN ? 'charm' : (L.bracelets.indexOf(p) > -1 ? 'bracelet' : 'chain'); }
  function addonList() {
    // The matching set bracelet leads, then necklaces, then the other bracelets.
    var set = L.bracelets.filter(function (p) { return p.set; });
    return set.concat(L.necklaces, L.bracelets.filter(function (p) { return !p.set; }));
  }

  /* ---------- shared side panel ---------- */

  function openPanel(cls, label, html) {
    closePanel(true);
    var el = document.createElement('div');
    el.id = PANEL_ID;
    el.className = 'fc-panel ' + cls;
    el.innerHTML =
      '<div class="fc-panel__overlay" data-fc-close></div>' +
      '<aside class="fc-panel__box" role="dialog" aria-label="' + esc(label) + '">' +
        '<button type="button" class="fc-panel__close" data-fc-close aria-label="Close">&times;</button>' +
        html +
      '</aside>';
    document.body.appendChild(el);
    document.documentElement.classList.add('fc-open');
    requestAnimationFrame(function () { el.classList.add('is-open'); });
    document.addEventListener('keydown', onKey);
    return el;
  }
  function closePanel(now) {
    var el = document.getElementById(PANEL_ID);
    document.documentElement.classList.remove('fc-open');
    document.removeEventListener('keydown', onKey);
    if (!el) return;
    if (now) { el.remove(); return; }
    el.classList.remove('is-open');
    setTimeout(function () { if (el.parentNode) el.remove(); }, 260);
  }
  function onKey(e) { if (e.key === 'Escape') closePanel(); }

  function variantSelect(p) {
    var avail = p.variants.filter(function (v) { return v.available; });
    if (avail.length < 2) return '';
    return '<select class="fc-select" data-fc-variant aria-label="Choose an option">' +
      avail.map(function (v) {
        return '<option value="' + v.id + '" data-price="' + v.price + '">' + esc(v.title) + ' (' + money(v.price) + ')</option>';
      }).join('') + '</select>';
  }
  function pickedVariant(scope, p) {
    var sel = scope.querySelector('[data-fc-variant]');
    var id = sel ? parseInt(sel.value, 10) : firstAvail(p).id;
    for (var i = 0; i < p.variants.length; i++) if (p.variants[i].id === id) return p.variants[i];
    return firstAvail(p);
  }
  function tabs(list) {
    var shown = list.filter(function (t) { return t.items.length; });
    if (shown.length < 2) return '';
    return '<div class="fc-tabs" role="tablist">' + shown.map(function (t, i) {
      return '<button type="button" role="tab" class="fc-tab' + (i === 0 ? ' is-on' : '') + '" data-fc-tab="' + t.key + '">' + esc(t.label) + '</button>';
    }).join('') + '</div>';
  }
  function bindTabs(el) {
    el.addEventListener('click', function (ev) {
      var tab = ev.target.closest('[data-fc-tab]');
      if (!tab) return;
      var key = tab.getAttribute('data-fc-tab');
      el.querySelectorAll('[data-fc-tab]').forEach(function (t) { t.classList.toggle('is-on', t === tab); });
      el.querySelectorAll('[data-fc-pane]').forEach(function (p) { p.hidden = p.getAttribute('data-fc-pane') !== key; });
    });
  }

  /* ---------- 1. Browse chains (before adding) ---------- */

  function browseCard(p) {
    var on = chosen && chosen.productId === p.id;
    return '<div class="fc-card' + (on ? ' is-on' : '') + '" data-fc-product="' + p.id + '">' +
      '<a class="fc-card__img" href="' + esc(p.url) + '" target="_blank" rel="noopener">' +
        (p.img ? '<img src="' + esc(p.img) + '" alt="" loading="lazy">' : '') +
        (p.set ? '<span class="fc-badge">Matching set</span>' : '') + '</a>' +
      '<div class="fc-card__title">' + esc(p.title) + '</div>' +
      '<div class="fc-card__price">' + money(firstAvail(p).price) + '</div>' +
      variantSelect(p) +
      '<button type="button" class="fc-btn fc-btn--line" data-fc-choose>' + (on ? 'Selected' : (CHAIN ? 'Add with ' + CK : 'Add with charm')) + '</button>' +
    '</div>';
  }

  function openBrowse() {
    var groups = CHAIN ? [{ key: 'charms', label: 'Charms', items: L.charms }] : [
      { key: 'necklaces', label: 'Necklaces', items: L.necklaces },
      { key: 'bracelets', label: 'Bracelets', items: L.bracelets }
    ];
    var first = groups.filter(function (g) { return g.items.length; })[0];
    var html =
      '<div class="fc-panel__head"><h2 class="fc-panel__title">' + (CHAIN ? 'Charms for ' : 'Style ') + esc(FC.charm.title) + (CHAIN ? '' : ' with:') + '</h2></div>' +
      '<div class="fc-panel__scroll">' +
        (FC.charm.img ? '<div class="fc-hero"><img src="' + esc(FC.charm.img) + '" alt=""></div>' : '') +
        tabs(groups) +
        groups.filter(function (g) { return g.items.length; }).map(function (g) {
          return '<div class="fc-grid" data-fc-pane="' + g.key + '"' + (g === first ? '' : ' hidden') + '>' +
            g.items.map(browseCard).join('') + '</div>';
        }).join('') +
      '</div>';
    var el = openPanel('fc-panel--browse', CHAIN ? 'Browse charms for this ' + CK : 'Browse chains for charms', html);
    bindTabs(el);
    el.addEventListener('click', function (ev) {
      if (ev.target.closest('[data-fc-close]')) { closePanel(); return; }
      var btn = ev.target.closest('[data-fc-choose]');
      if (!btn) return;
      var card = btn.closest('[data-fc-product]');
      var p = findProduct(parseInt(card.getAttribute('data-fc-product'), 10));
      if (!p) return;
      var v = pickedVariant(card, p);
      chosen = { productId: p.id, variantId: v.id, title: p.title, variant: p.variants.length > 1 ? v.title : '', price: v.price, img: p.img, kind: kindOf(p) };
      renderChosen();
      closePanel();
    });
  }

  function renderChosen() {
    var box = document.querySelector('[data-fc-chosen]');
    var label = document.querySelector('[data-bs-atc-label]');
    if (label && baseLabel === null) baseLabel = label.textContent;
    if (box) {
      box.hidden = !chosen;
      box.innerHTML = chosen ?
        (chosen.img ? '<img class="fc-chosen__img" src="' + esc(chosen.img) + '" alt="">' : '') +
        '<div class="fc-chosen__text"><span class="fc-chosen__eyebrow">Added with your ' + (CHAIN ? CK : 'charm') + '</span>' +
          '<span class="fc-chosen__title">' + esc(chosen.title) + (chosen.variant ? ', ' + esc(chosen.variant) : '') + '</span>' +
          '<span class="fc-chosen__price">+ ' + money(chosen.price) + '</span></div>' +
        '<button type="button" class="fc-chosen__remove" data-fc-remove>Remove</button>' : '';
    }
    if (label && !label.closest('button').disabled) label.textContent = atcLabel();
  }

  function atcLabel() {
    if (!chosen) return baseLabel || 'Add to bag';
    return CHAIN ? 'Add ' + CK + ' + charm to bag' : 'Add charm + ' + chosen.kind + ' to bag';
  }

  /* ---------- 2. After adding: Add on / Style with ---------- */

  function addedRow(item) {
    return '<div class="fc-added">' +
      (item.image ? '<img class="fc-added__img" src="' + esc(item.image) + '" alt="">' : '') +
      '<div><div class="fc-row__title">' + esc(item.product_title) + '</div>' +
      '<div class="fc-row__price">' + money(item.final_line_price || item.price) + '</div>' +
      (item.variant_title ? '<div class="fc-row__meta">' + esc(item.variant_title) + '</div>' : '') + '</div></div>';
  }

  function offerRow(p, skip) {
    var done = skip.indexOf(p.id) > -1;
    return '<div class="fc-row" data-fc-product="' + p.id + '">' +
      '<a class="fc-row__img" href="' + esc(p.url) + '">' + (p.img ? '<img src="' + esc(p.img) + '" alt="" loading="lazy">' : '') + '</a>' +
      '<div class="fc-row__body">' +
        (p.set ? '<span class="fc-badge fc-badge--inline">Matching set</span>' : '') +
        '<a class="fc-row__title" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
        '<div class="fc-row__price">' + money(firstAvail(p).price) + '</div>' +
        variantSelect(p) +
        '<button type="button" class="fc-btn fc-btn--add" data-fc-add' + (done ? ' disabled' : '') + '>' + (done ? 'In your bag' : 'Add +') + '</button>' +
      '</div></div>';
  }

  function cartCount(el) {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) { var n = el.querySelector('[data-fc-count]'); if (n) n.textContent = c.item_count; })
      .catch(function () {});
  }

  /* styleList: when given (a base added from Shop the look), the panel offers
     those charms as "Style with" instead of this page's own lists. */
  function afterAdd(res, styleList) {
    var items = (res && res.items) ? res.items : (res ? [res] : []);
    var inBag = items.map(function (i) { return i.product_id; });
    var groups = styleList ? [{ key: 'style', label: 'Style with', items: styleList }] :
      CHAIN ? [{ key: 'charms', label: 'Style with', items: L.charms }] : [
      { key: 'addon', label: 'Add on', items: addonList() },
      { key: 'style', label: 'Style with', items: L.style }
    ];
    var shown = groups.filter(function (g) { return g.items.length; });
    var html =
      '<div class="fc-panel__head"><h2 class="fc-panel__title">Added to your bag</h2></div>' +
      '<div class="fc-panel__scroll">' +
        items.map(addedRow).join('') +
        '<button type="button" class="fc-btn fc-btn--solid" data-fc-viewbag>View bag (<span data-fc-count>&hellip;</span>)</button>' +
        (shown.length ? tabs(groups) + (shown.length === 1 ? '<div class="fc-subhead">' + esc(shown[0].label) + '</div>' : '') : '') +
        shown.map(function (g, i) {
          return '<div class="fc-list" data-fc-pane="' + g.key + '"' + (i === 0 ? '' : ' hidden') + '>' +
            g.items.map(function (p) { return offerRow(p, inBag); }).join('') + '</div>';
        }).join('') +
        '<button type="button" class="fc-continue" data-fc-close>Continue shopping</button>' +
      '</div>';
    var el = openPanel('fc-panel--added', 'Added to your bag', html);
    bindTabs(el);
    cartCount(el);
    el.addEventListener('click', function (ev) {
      if (ev.target.closest('[data-fc-close]')) { closePanel(); return; }
      if (ev.target.closest('[data-fc-viewbag]')) {
        closePanel(true);
        if (window.jQuery) window.jQuery('body').trigger('added.ajaxProduct');
        return;
      }
      var btn = ev.target.closest('[data-fc-add]');
      if (!btn || btn.disabled) return;
      var row = btn.closest('[data-fc-product]');
      var p = findProduct(parseInt(row.getAttribute('data-fc-product'), 10));
      if (!p) return;
      var v = pickedVariant(row, p);
      btn.disabled = true;
      btn.textContent = 'Adding...';
      fetch('/cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: v.id, quantity: 1 })
      }).then(function (r) {
        if (!r.ok) throw new Error('add');
        btn.textContent = 'Added';
        btn.classList.add('is-done');
        cartCount(el);
      }).catch(function () {
        btn.disabled = false;
        btn.textContent = 'Sold out, try another';
      });
    });
  }

  /* ---------- 3. Build your charm stack: Shop the look ---------- */

  function lookCard(p) {
    return '<div class="fc-look__card" data-fc-product="' + p.id + '">' +
      '<div class="fc-look__media">' +
        '<a href="' + esc(p.url) + '">' + (p.img ? '<img src="' + esc(p.img) + '" alt="" loading="lazy">' : '') + '</a>' +
        '<button type="button" class="fc-look__add" data-fc-look-add>Add +</button>' +
      '</div>' +
      '<a class="fc-card__title" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
      '<div class="fc-card__price">' + (p.variants.length > 1 ? 'From ' : '') + money(firstAvail(p).price) + '</div>' +
      variantSelect(p) +
    '</div>';
  }

  function charmsFor(p) {
    var pool = FC.pool || [];
    return (p.compat || []).map(function (id) {
      for (var i = 0; i < pool.length; i++) if (pool[i].id === id) return pool[i];
      return null;
    }).filter(Boolean);
  }

  function openLook(look) {
    var html =
      '<div class="fc-panel__head"><h2 class="fc-panel__title">Shop the look</h2></div>' +
      '<div class="fc-panel__scroll"><div class="fc-look">' +
        (look.img ? '<div class="fc-look__photo"><img src="' + esc(look.img) + '" alt="' + esc(look.title) + '"></div>' : '') +
        '<div class="fc-look__grid">' + look.items.map(lookCard).join('') + '</div>' +
      '</div>' +
      '<button type="button" class="fc-btn fc-btn--solid fc-look__bag" data-fc-viewbag hidden>View bag (<span data-fc-count>&hellip;</span>)</button>' +
      '</div>';
    var el = openPanel('fc-panel--look', 'Shop the look', html);
    el.addEventListener('click', function (ev) {
      if (ev.target.closest('[data-fc-close]')) { closePanel(); return; }
      if (ev.target.closest('[data-fc-viewbag]')) {
        closePanel(true);
        if (window.jQuery) window.jQuery('body').trigger('added.ajaxProduct');
        return;
      }
      var btn = ev.target.closest('[data-fc-look-add]');
      if (!btn || btn.disabled) return;
      var card = btn.closest('[data-fc-product]');
      var p = findProduct(parseInt(card.getAttribute('data-fc-product'), 10));
      if (!p) return;
      var v = pickedVariant(card, p);
      btn.disabled = true;
      btn.textContent = 'Adding...';
      fetch('/cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: v.id, quantity: 1 })
      }).then(function (r) {
        if (!r.ok) throw new Error('add');
        return r.json();
      }).then(function (item) {
        btn.textContent = 'Added';
        btn.classList.add('is-done');
        /* A base (chain or bracelet) goes straight on to the charms that fit
           it, like the necklace page: "Added to your bag" + Style with. */
        var fits = charmsFor(p);
        if (fits.length) { afterAdd(item, fits); return; }
        el.querySelector('[data-fc-viewbag]').hidden = false;
        cartCount(el);
      }).catch(function () {
        btn.disabled = false;
        btn.textContent = 'Sold out';
      });
    });
  }

  /* ---------- mount ---------- */

  function init() {
    var mount = document.querySelector('[data-fc-browse]');
    if (mount && CHAIN && L.charms.length) {
      mount.innerHTML = '<button type="button" class="fc-browse" data-fc-open>Browse charms for this ' + CK + ' <span aria-hidden="true">&rarr;</span></button>';
      mount.hidden = false;
    } else if (mount && (L.necklaces.length || L.bracelets.length)) {
      var what = L.necklaces.length && L.bracelets.length ? 'chains & bracelets' : (L.necklaces.length ? 'chains' : 'bracelets');
      mount.innerHTML = '<button type="button" class="fc-browse" data-fc-open>Browse ' + what + ' for this charm <span aria-hidden="true">&rarr;</span></button>';
      mount.hidden = false;
    }
    document.addEventListener('click', function (ev) {
      if (ev.target.closest('[data-fc-open]')) { openBrowse(); return; }
      var lookLink = ev.target.closest('[data-fc-look]');
      if (lookLink && FC.looks) {
        var look = FC.looks[parseInt(lookLink.getAttribute('data-fc-look'), 10)];
        if (look && look.items.length) { ev.preventDefault(); openLook(look); return; }
      }
      if (ev.target.closest('[data-fc-remove]')) { chosen = null; renderChosen(); }
    });
  }

  FC.selected = function () { return chosen; };
  FC.clear = function () { chosen = null; renderChosen(); };
  FC.atcLabel = atcLabel;
  FC.afterAdd = afterAdd;

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
